// libs
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { ToastContainer, toast } from 'react-toastify';
// components
import Logo from '../../components/logo';
import '../../assets/css/core.css';
import Footer from '../../components/footer';
import { useAuth } from '../../context/auth-context';

function Login() {
	const navigate = useNavigate();
	const { login } = useAuth();
	const [loading, setLoading] = useState(false);
	const {
		register,
		handleSubmit,
		formState: { errors },
		reset,
		trigger,
	} = useForm();

	const onSubmit = async (data) => {
		setLoading(true);

		const result = await login(data.username, data.password);

		if (result.success) {
			reset();
			toast.success('Login successful.');
			navigate('/dashboard', { replace: true });
		} else {
			toast.error(result.message || 'Invalid credentials. Please try again.');
			setLoading(false);
		}
	};

	return (
		<div>
			<Container>
				<Row>
					<Col md={{ span: 4, offset: 4 }}>
						<div className="login-form bg-light mt-4 p-4">
							<form className="g-3" onSubmit={handleSubmit(onSubmit)} noValidate>
								<div className="text-center"><Logo /></div>
								<p className="text-center text-muted fs-14rem mb-3">
									Sign in with your seller account email
								</p>
								<Col>
									<div className="py-2">
										<label className="vt-txt-dark-blue">Email</label>
										<input
											type="email"
											className={`form-control ${errors.username ? 'invalid' : ''}`}
											{...register('username', {
												required: 'Email is required',
												pattern: {
													value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
													message: 'Enter a valid email address',
												},
											})}
											onKeyUp={() => trigger('username')}
											placeholder="seller@example.com"
											autoComplete="username"
											disabled={loading}
										/>
										{errors.username && (
											<small className="text-danger">{errors.username.message}</small>
										)}
									</div>
								</Col>
								<Col>
									<div className="py-2">
										<label className="vt-txt-dark-blue">Password</label>
										<input
											type="password"
											className={`form-control ${errors.password ? 'invalid' : ''}`}
											{...register('password', { required: 'Password is required' })}
											onKeyUp={() => trigger('password')}
											placeholder="Password"
											autoComplete="current-password"
											disabled={loading}
										/>
										{errors.password && (
											<small className="text-danger">{errors.password.message}</small>
										)}
									</div>
								</Col>
								<Col className="d-grid gap-2">
									<Button
										variant="primary"
										type="submit"
										className="fs-14rem border-0 vt-primary-btn pb-2"
										disabled={loading}
									>
										{loading ? 'Signing in...' : 'Login'}
									</Button>
								</Col>
							</form>
							<hr className="mt-4" />
							<Col>
								<p className="text-center mb-0 vt-txt-dark-blue">
									Forgot your password?{' '}
									<a href="/forgot-password" className="foot-link vt-txt-dark-blue">
										Reset password
									</a>
								</p>
							</Col>
						</div>
					</Col>
				</Row>
			</Container>
			<ToastContainer
				position="top-right"
				autoClose={5000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
			/>
			<div className="fixed-bottom"><Footer /></div>
		</div>
	);
}

export default Login;
